import { IconButton, IconButtonProps, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { forwardRef } from 'react';

import styles from './sidebarFooterButton.module.scss';

type SidebarFooterButtonProps = IconButtonProps & {
  label?: string;
};

export const SidebarFooterButton = forwardRef<
  HTMLButtonElement,
  SidebarFooterButtonProps
>(function SidebarFooterButton({ className, label, ...iconButtonProps }, ref) {
  const button = (
    <IconButton
      ref={ref}
      variant="tertiary"
      size="large"
      iconProps={{ size: 20 }}
      {...iconButtonProps}
      className={classnames(styles.button, className)}
    />
  );

  if (label) {
    return <Tooltip content={label}>{button}</Tooltip>;
  }

  return button;
});
